enum Fields {
    FirstName = 'firstName',
    LastName = 'lastName',
    Email = 'email',
    Password ='password',
    ConfirmPassword = 'confirmPassword'
}

export default Fields;